"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.store = exports.defaultNodeTypeList = exports.defaultNodeList = void 0;
var store = exports.store = {};
var defaultNodeList = exports.defaultNodeList = [{
  id: 'startEvent',
  type: 'start',
  title: '开始'
}, {
  id: 'endEvent',
  type: 'end',
  title: '结束'
}];
var defaultNodeTypeList = exports.defaultNodeTypeList = [{
  name: '普通节点',
  list: [{
    type: 'normal',
    name: '普通节点'
  }]
}, {
  name: '分支节点',
  list: [{
    type: 'condition',
    name: '条件分支'
  }]
}];